import React from 'react'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";

export const EyeGlassesSlider = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 4
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  return (
    <div className="mx-auto px-5 lg:px-24 xl:mb-28 mb-8">
      <div className="flex place-content-between border-b-[1px] border-gray-300">
        <div className="lg:text-2xl text-xl font-light">EYEGLASSES</div>
        <div className=""><Link to="#" className="text-cyan-500">View Range</Link></div>
      </div>
      <div className="eyeglass">
        <Carousel responsive={responsive} infinite={true}>
          <Link to="#"><img src="images/frame-1.jpeg" alt="Image1" /></Link>
          <Link to="#"><img src="images/frame-2.jpeg" alt="Image1" /></Link>
          <Link to="#"><img src="images/frame-3.jpeg" alt="Image1" /></Link>
          <Link to="#"><img src="images/frame-4.jpeg" alt="Image1" /></Link>
          <Link to="#"><img src="images/frame-5.jpeg" alt="Image1" /></Link>
          <Link to="#"><img src="images/frame-6.jpeg" alt="Image1" /></Link>
        </Carousel>
      </div>
    </div>
  )
}